<template>
<div id="appdettaglio" v-cloak>

    <b-container fluid>
        <b-row>
            <b-col sm="12" md="8" lg="6" class="mx-auto text-center" style="width: 95%;margin-top:15px;">
                <b-card :header="(this.$route.params.id != null ? 'Modulistica #' + this.$route.params.id : 'Nuova modulistica')">

                    <b-container fluid class="mx-auto text-left" v-if="showdettaglio2 && (this.$route.params.id == null || showdettaglio1)">
                         <b-row class="my-1">
                                <b-col sm="3"><label for="titolo">Titolo:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="modulistica.titolo" id="titolo" type="text"></b-form-input>
                                    </b-col>
                                </b-row>                                                                                      
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="note">Note:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-textarea id="note" v-model="modulistica.note" :rows="3"></b-form-textarea>
                                    </b-col>
                                </b-row>
                                
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="categoria">Categoria:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="modulistica.id_categoria" :options="options_categorie" id="categoria">
                                            <template slot="first">
                                                      <!-- this slot appears above the options from 'options' prop -->
                                                      <option :value="null" disabled>-- Seleziona --</option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="visibilità">Visibilità:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-select v-model="modulistica.visibilita" :options="options_visibilità" id="visibilità">
                                            <template slot="first">
                                                      <!-- this slot appears above the options from 'options' prop -->
                                                      <option :value="null" disabled>-- Seleziona --</option>
                                            </template>
                                        </b-form-select>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="datainizio">Data inizio:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="modulistica.datainizio" id="datainizio" type="date"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="my-1">
                                    <b-col sm="3"><label for="datafine">Data fine:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="modulistica.datafine" id="datafine" type="date"></b-form-input>
                                    </b-col>
                                </b-row> 
                                <b-row class="my-1" v-if="modulistica.id != null" >
                                    <b-col sm="3"><label for="uteins">Allegato:</label></b-col>
                                    <b-col sm="6">
                                        <b-form-input v-model="modulistica.allegatoVis" id="allegatoVis" type="text" disabled></b-form-input>
                                    </b-col>
                                    <b-col sm="3">
                                        <b-btn style="margin:0px 0px 1px 2px;" variant="info" size="sm" @click.stop="insAllegato()">Inserisci</b-btn>
                                        <b-btn v-if="modulistica.idallegato != ''" style="margin:0px 0px 1px 2px;" size="sm" @click.stop="details()">Visualizza</b-btn>
                                    </b-col>    
                                </b-row>
                                <b-row class="my-1" v-if="modulistica.id != null">
                                    <b-col sm="3"><label for="datains">Data inserimento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="modulistica.datains" id="datains" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>                                
                                <b-row class="my-1" v-if="modulistica.id != null">
                                    <b-col sm="3"><label for="uteins">Utente inserimento:</label></b-col>
                                    <b-col sm="9">
                                        <b-form-input v-model="modulistica.uteins" id="uteins" type="text" disabled></b-form-input>
                                    </b-col>
                                </b-row>                                

                                <b-row class="my-3">

                                    <b-col sm="6" offset-sm="3">
                                        <b-button block size="md" variant="outline-primary" v-on:click="insert()">
                                            <div v-if="modulistica.id != null">
                                                Salva
                                            </div>
                                            <div v-else>
                                                Inserisci
                                            </div>                                            
                                        </b-button>
                                    </b-col>
                                </b-row>
                    </b-container>

                    <b-alert :show="showerror" variant="danger">{{ error }}</b-alert>
                    <b-alert :show="dismissCountDown" dismissible variant="success" @dismissed="dismissCountdown=0" @dismiss-count-down="countDownChanged">
                        Operazione effettuata con successo
                    </b-alert>


                </b-card>
            </b-col>
        </b-row>
    </b-container>

    <!-- Modal Component Upload -->
    <b-modal v-model="uploadModal.show" title="Seleziona il file da inserire" @hidden="onHidden">
        <!-- <p class="my-2">Seleziona il file da inserire</p> -->
        <b-btn id="browse" ref="browse" size="md" variant="primary">Sfoglia...</b-btn>
        <h5>{{uploadModal.descrCaricamento}}</h5>
        <b-progress v-if="uploadModal.showPercent" :value="uploadModal.percentCaricamento" :max="100" show-progress animated></b-progress>
        <b-alert style="margin-top:10px;" :show="(uploadModal.errorCaricamento != '')" variant="danger">{{ uploadModal.errorCaricamento }}</b-alert>
        <div slot="modal-footer" class="w-100">
            <b-btn size="sm" class="float-right" variant="primary" @click="caricaItem()" style="margin: 2px;">
                Inserisci
            </b-btn>
            <b-btn size="sm" class="float-right" variant="secondary" @click="uploadModal.show=false" style="margin: 2px;">
                Annulla
            </b-btn>
        </div>
    </b-modal>



</div>
</template>

<script>

import {
    NAMESPACE,
    TOKENUPLOAD
} from '../config.js'

import {
    Visibilità,
    Categoria
} from '../classes.js'

import {
    uuidv4
} from '../util.js'

import {
    ctrlVismenu,
    ctrlViscategoria 
} from '../util.js'

import {
    Resumable
} from '../resumable.js'

export default {    
    name: 'appdettaglio',
    
    data: function () {
        return {                       
            namespace: NAMESPACE,            
            r: new Resumable({
                target: '',
                testChunks: true
            }),
            modulistica: {
                id: this.$route.params.id || null,
                datains: null,
                id_categoria: null,
                visibilita: '',
                uteins: '',               
                titolo: '',
                note: '',  
                allegato: '',
                allegatoVis: '',
                idallegato: '',
                datainizio: '', 
                datafine: ''
            },              
            error: '',
            showerror: false,
            showdettaglio1: false,
            showdettaglio2: false,
            flagTipo: '',
            dismissSecs: 5,
            dismissCountDown: 0,            
            options_categorie: [],
            options_visibilità: [],
            uploadModal: {
                show: false,
                descrCaricamento: '',
                showPercent: false,
                percentCaricamento: 0,
                errorCaricamento: '',
                uuidv4: ''
            }       
        };
    },
    methods: {
        caricaDati(id){
            
            var appdettaglio = this;

            var id = this.modulistica.id; //se è la prima volta si prova a prendere da getid 

            if (id != null) {

                var token = localStorage.getItem('token');                

                this.axios.get(NAMESPACE + 'rest/modulistica/' + id, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;
                                if (res.length > 0) {
                                    this.modulistica = res[0];

                                    if((res[0].allegato || "") != ""){
                                        var split = res[0].allegato.split('/');
                                        this.modulistica.allegatoVis = decodeURI(split[split.length - 1]);
                                    }

                                    this.showdettaglio1 = true;

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            appdettaglio.showerror = true;
                            appdettaglio.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });            
            }

             //////////////////////////////////////
            const tipoPagina = 'Modulistica';
            //////////////////////////////////////

            //creo la tendina visibilità
            var visibilità = new Visibilità();
            var options_vis = [];
            for (var i = 0; i < Object.keys(visibilità.getListaTipi()).length; i++) {
                options_vis.push({
                    value: Object.keys(visibilità.getListaTipi())[i],
                    text: visibilità.getTipoByFlag(Object.keys(visibilità.getListaTipi())[i])
                });
            }
            this.options_visibilità = options_vis;

            //recupero il valore del flag del tipo della categoria
            var cat = new Categoria();
            var tipi = cat.getListaTipi();
            var keys = Object.keys(tipi);
            var flagTipo = "";
            for (var i = 0; i < keys.length; i++) {
                if (tipi[keys[i]] == tipoPagina) {
                    flagTipo = keys[i];
                }
            }

            this.flagTipo = flagTipo;

            //chiamo il servizio che mi restituisce tutte le categorie di quel tipo
            var token = localStorage.getItem('token');
            this.axios.get(NAMESPACE + 'rest/categorie/tipo/' + flagTipo, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    // JSON responses are automatically parsed.
                    try {

                        if (!response.data.error) {

                            if (response.data.token != null) localStorage.setItem('token', response.data.token);

                            var res = response.data.message;
                            if (res.length > 0) {

                                var options = [];
                                for (var i = 0; i < res.length; i++) {
                                    options.push({
                                        value: res[i].id,
                                        text: res[i].descrizione
                                    });
                                }

                                this.options_categorie = options;

                                this.options_categorie = this.options_categorie.filter(function (element) {                       
                                    return ctrlViscategoria(element.value);
                                });

                                this.showdettaglio2 = true;

                            } else {
                                throw new Error("Errore categorie non trovate!");
                            }


                        } else {
                            throw new Error(response.data.message);
                        }


                    } catch (e) {
                        appdettaglio.showerror = true;
                        appdettaglio.error = "Errore: " + e.message;
                    }

                })
                .catch(e => {
                    appdettaglio.showerror = true;
                    appdettaglio.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                });

        },
        countDownChanged(dismissCountDown) {
            this.dismissCountDown = dismissCountDown;
        },
        onHidden(evt) {
            this.r.cancel();
        },  
        onFiltered(filteredItems) {
            // Trigger pagination to update the number of buttons/pages due to filtering
            this.sociModal.totalRows = filteredItems.length;
            this.sociModal.currentPage = 1;
        },
        details() {
            window.open(this.modulistica.allegato, '_blank');
        },
        insAllegato() {

            this.uploadModal.showPercent = false;
            this.uploadModal.descrCaricamento = '';
            this.uploadModal.percentCaricamento = 0;
            this.uploadModal.errorCaricamento = '';
            this.uploadModal.show = true;
            this.uploadModal.uuidv4 = uuidv4();

            this.$nextTick(() => {
                this.prepareUpload();
            });

        },
        caricaItem() {
            if (this.r.files.length == 0) {
                alert("Nessun file selezionato!");
            } else {
                this.r.opts.target = NAMESPACE + 'rest/upload.php?id=' + this.uploadModal.uuidv4 + '&tokenupload=' + TOKENUPLOAD;
                this.uploadModal.showPercent = true;
                this.r.upload();
            }
        },
        allegatiImmagini() {

            this.$router.push({
                path: `/app/allegati/id/${this.modulistica.id}/tipo/${this.flagTipo}`
            });

        },

        insert() {

            var appdettaglio = this;

            if (this.modulistica.titolo == "") {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo titolo vuoto!";

            } else if (this.modulistica.datainizio == "" || this.modulistica.datainizio == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo data inizio vuoto!";

            } else if (this.modulistica.datafine == "" || this.modulistica.datafine == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Campo data fine vuoto!";

            } else if (this.modulistica.datafine < this.modulistica.datainizio) { //sono stringhe yyyy-mm-dd
                appdettaglio.showerror = true;
                appdettaglio.error = "Data inizio maggiore di data fine!";

            } else if (this.modulistica.id_categoria == null) {
                appdettaglio.showerror = true;
                appdettaglio.error = "Categoria non selezionata!";

            } else if ((this.modulistica.visibilita || '') == '') {
                appdettaglio.showerror = true;
                appdettaglio.error = "Visibilità non selezionata!";

            } else {

                var json = JSON.stringify(this.modulistica);

                var token = localStorage.getItem('token');
                this.axios.post(NAMESPACE + 'rest/modulistica', json, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        // JSON responses are automatically parsed.
                        try {

                            if (!response.data.error) {

                                if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                var res = response.data.message;                                
                                if (res.length > 0) {

                                    this.modulistica = res[0];

                                    if((res[0].allegato || "") != ""){
                                        var split = res[0].allegato.split('/');
                                        this.modulistica.allegatoVis = decodeURI(split[split.length - 1]);
                                    }
                                
                                    this.showerror = false;
                                    this.showdettaglio1 = true; //anche se non dovrebbe servire                                 
                                    this.dismissCountDown = this.dismissSecs;

                                    //this.$route.params.id = this.modulistica.id;

                                    this.$router.replace('/app/dettagliomodulistica/' + this.modulistica.id);

                                } else {
                                    throw new Error("Errore dati non trovati!");
                                }


                            } else {
                                throw new Error(response.data.message);
                            }


                        } catch (e) {
                            this.showerror = true;
                            this.error = "Errore: " + e.message;
                        }

                    })
                    .catch(e => {
                        this.showerror = true;
                        this.error = "Errore: " + (e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message);
                    });

            }

        },
        prepareUpload(){

            //non rimuovere serve per resettare l'oggetto a ogni caricamento
            //altrimenti carica i file duplicandoli
            this.r = new Resumable({
                target: '',
                testChunks: true
            });

            this.r.assignBrowse(this.$refs.browse, false);

            var rg = this.r;
            var appdettaglio = this;

            this.r.on('fileAdded', function(file, event) {
                rg.files = rg.files.slice(-1); //prendo sempre solo l'ultimo file                   

                //ATTENZIONE: non cambiare è come se fosse una funzione esterna e quindi il this qui non funzionerebbe
                appdettaglio.uploadModal.descrCaricamento = file.fileName;

            });

            this.r.on('fileSuccess', function(file, message) {
                try {
                    
                    //console.log("fileSuccess" + message.trim())

                    var res = JSON.parse(message.trim());

                    if (!res.error) {
                        appdettaglio.uploadModal.percentCaricamento = 100;
                        var json = JSON.stringify({
                            'id': null,
                            'id_scheda': appdettaglio.modulistica.id,
                            'tipo': appdettaglio.flagTipo,
                            's3': res.message.s3,
                            'allegato': encodeURI(appdettaglio.uploadModal.uuidv4 + '/' + file.fileName)
                        });

                        var token = localStorage.getItem('token');
                        appdettaglio.axios.post(NAMESPACE + 'rest/allegato', json, {
                                headers: {
                                    'Content-Type': 'application/json',
                                    'Authorization': token
                                }
                            })
                            .then(response => {

                                // JSON responses are automatically parsed.
                                try {

                                    if (!response.data.error) {

                                        if (response.data.token != null) localStorage.setItem('token', response.data.token);

                                        appdettaglio.caricaDati(appdettaglio.modulistica.id);
                                        setTimeout(function() {
                                            appdettaglio.uploadModal.show = false;
                                        }, 1000);

                                    } else {
                                        throw new Error(response.data.message);
                                    }


                                } catch (e) {
                                    throw new Error(e.message);
                                }

                            })
                            .catch(e => {
                                throw new Error((e.response.data.message instanceof Object ? "Errore interno API" : e.response.data.message));
                            });

                    } else {
                        throw new Error(res.message);
                    }

                } catch (e) {
                    appdettaglio.uploadModal.errorCaricamento = "Errore: " + e.message;
                }

            });

            this.r.on('progress', function() {
                appdettaglio.uploadModal.percentCaricamento = rg.progress() * 100;
                //alert("Perc car " + appdettaglio.uploadModal.percentCaricamento);
                //FORZATURA NON BELLA
                if (rg.progress() * 100 === 100) {
                    setTimeout(function() {
                        appdettaglio.uploadModal.show = false;
                    }, 1000);
                }


            });

            this.r.on('error', function(message, file) {
                appdettaglio.uploadModal.errorCaricamento = message;
            });

        }

    },
    created: function () {    
        if(!ctrlVismenu("L")){
            this.$router.replace('/accessdenied');
            return;
        }

        this.caricaDati(this.id); 
    }

}
</script>
